  /* eslint max-len: ["error", 200] */
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { api } from '../../services/api'
import { publishTracking } from '../../services/tracking'
import './gp-web-forgot-password.css';
import LoadingSvg from '../loading-svg'

export default class GPWebForgotPassword extends Component {
  constructor(props) {
    super(props)

    this.state = {
      email: '',
      resetSent: false,
      uiPending: false,
    }
  }

  emailHandler = (e) => {
    this.setState({
      email: e.target.value,
    })
  }

  sendEmail = (e) => {
    e.preventDefault()

    if (!this.state.resetSent) {
      this.setState({ uiPending: true })
      const queryParams = new URLSearchParams(this.props.location.search)
      api.resetPassword(this.state.email, queryParams.get('site') || '', queryParams.get('platform') || '')
      .then(() => {
        publishTracking({
          userAction: 'forgot pass submit',
          event: 'event149',
        })
      })

      setTimeout(() => {
        this.setState({ resetSent: true })
      }, 3000)
    }
  }

  render() {
    const { t } = this.props
    const { resetSent, uiPending } = this.state

    return (
      <div className="wrapper">

        <h1 className="title">{t('GP_FORGOT_HEADER')}</h1>
        
        <div className="modal-content">

          <form className="forgot-email-dialog" onSubmit={this.sendEmail}>

            <p className="xs-text-8 xs-text-black italic xs-px4 xs-mb4 xs-text-center xs-regular italic">
              {t('GP_FORGOT_SUBTITLE')}
            </p>

            <input
              type="email"
              onChange={this.emailHandler}
              className={'sign-with email email-reset xs-mb0 text-input xs-mb4 xs-text-7 xs-regular'}
              placeholder={t('GP_YOUR_EMAIL')}
              autoComplete="email"
              required
            />

            {resetSent
              ? <span className="xs-text-center xs-px4 xs-block xs-text-8 xs-regular italic">{t('GP_RECEIVE_EMAIL')}</span>
              : <button type="submit" className={`button-primary xs-border-none xs-text-white xs-py3 xs-col-12 ${uiPending && 'disabled'}`}>
                {uiPending
                  ? <LoadingSvg />
                  : t('GP_SEND_LINK')
                }
              </button>
            }
          </form>

        </div>
      </div>
    )
  }
}

GPWebForgotPassword.propTypes = {
  t: PropTypes.func.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/gp-web-forgot-password/gp-web-forgot-password.js